import { PendingChangeType } from "@repo/api";
import { cs, NumberToCZK } from "@repo/ui";
import format from "date-fns/format";
import { t } from "i18next";

type PensionPendingChangeDescriptionItem = {
    validFromDate: string | Date;
    changeType: PendingChangeType;
    detail: {
        newClientContribution?: number | null;
        willEmployerContribute?: boolean | null;
    };
};

export const contributionCoreSystemChangeDescription = (
    pendingChanges: PensionPendingChangeDescriptionItem[] | undefined,
    monthlyContributionClient: number | undefined,
) => {
    return pendingChanges?.map((change) => {
        const validFrom = format(new Date(change.validFromDate), "d. M. yyyy");
        if (
            change.detail.newClientContribution &&
            monthlyContributionClient &&
            Number(change.detail.newClientContribution) !== Number(monthlyContributionClient)
        ) {
            return `${t("global.from")} ${validFrom} ${t("investmentStrategy.changePensionContribution.newContributionLabel")} ${NumberToCZK(change.detail.newClientContribution)}.`;
        }

        return null;
    });
};

export const employerContributionCoreSystemChangeDescription = (
    pendingChanges: PensionPendingChangeDescriptionItem[] | undefined,
    doesEmployerContribute: boolean,
) => {
    if (pendingChanges) {
        const contributionChange = pendingChanges.find(
            (change) => change.changeType === PendingChangeType.ChangeContribution,
        );

        if (contributionChange === undefined) return null;

        const willEmployerContribute = contributionChange.detail.willEmployerContribute;
        if (
            willEmployerContribute === undefined ||
            willEmployerContribute === null ||
            willEmployerContribute === doesEmployerContribute
        )
            return null;

        const validFrom = format(new Date(contributionChange.validFromDate), "d. M. yyyy");
        const employerContributes = contributionChange.detail.willEmployerContribute
            ? cs.global.will
            : cs.global.willNot;
        return `${t("global.from")} ${validFrom} ${t("investmentStrategy.changePensionContribution.employerContributionLabel")} ${employerContributes} ${t("global.contribute")}.`;
    }
};
